import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { modelApiAction } from 'cio/utils/model-api-actions';
import { getFileExtension, getUploadFn, SignResponse } from 'cio/utils/uploads';
import UserOtherAccountModel from './user-other-account';

export const ASSETS_DEFAULT_SORT_BY = 'created_at';
export const ASSETS_DEFAULT_ASC = false;

export type AssetsQueryParams = {
  folderId: string | null;
  page: number;
  sortBy: string;
  sortAsc: boolean;
  search: string;
};

export default class AssetModel extends Model {
  @attr('string') name!: string;
  @attr('boolean') isDir!: boolean;
  @attr('boolean') inUse!: boolean;
  @attr('string') path!: string;
  @attr('number') size!: number;
  @attr('number') createdAt!: number;
  @attr('number') updatedAt!: number;
  @attr('string') parentId!: string | null;

  @attr() createdBy!: UserOtherAccountModel;
  @attr() updatedBy!: UserOtherAccountModel;

  get isDeletable() {
    if (this.isDir) {
      return this.size === 0;
    }

    return true;
  }

  get isImage() {
    return !this.isDir && !this.isPdf;
  }

  get isPdf() {
    return !this.isDir && this.path?.toLowerCase().endsWith('.pdf') === true;
  }

  signFileUpload = modelApiAction<{ name: string; type: string; size: string }, SignResponse & Record<string, any>>({
    path: 'sign',
    type: 'POST',
  });
  syncFileUpload = modelApiAction({
    path: '',
    type: 'POST',
    before(this: AssetModel, data: { fileType: string }) {
      return {
        asset: {
          name: this.name,
          path: this.path,
          parent_id: this.parentId,
          size: this.size,
        },
        file_type: data.fileType,
      };
    },
  });

  async upload(file: File) {
    if (this.isDir === true) {
      return;
    }

    let json = await this.signFileUpload({
      name: `${new Date().getTime()}_${file.name}`,
      type: file.type,
      size: String(file.size),
    });

    let renamedFile = new File([file], json.filename_replacement ?? file.name, { type: file.type });

    let { uploadFn, data } = getUploadFn(json, file.type);
    let { key } = await uploadFn(renamedFile, data, {});
    let fileType = getFileExtension(this.name);

    this.path = key;

    return await this.syncFileUpload({ fileType });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    asset: AssetModel;
  }
}
